import React from 'react'
import DetailCard from './DetailCard'
import DetailRows from './DetailRows'
import MeterIcon from '@/assets/DetailsCards_icons/meter_info_icon.png'
import { buildDetailCards, cardTitles } from '@/utils/consumerDetailCards'

interface MeterInfoCardProps {
  data?: any
  isEditMode?: boolean
  editedData?: Record<string, any>
  onFieldChange?: (field: string, value: any) => void
  resourceHeaders?: Record<string, string>
  langKey?: string
}

const MeterInfoCard: React.FC<MeterInfoCardProps> = ({
  data,
  isEditMode = false,
  editedData = {},
  onFieldChange,
  resourceHeaders = {},
  langKey = 'he',
}) => (
  <DetailCard
    title={cardTitles(langKey).meter}
    icon={
      <img
        src={MeterIcon}
        alt="meter"
        style={{ width: 18, height: 18, transform: 'scaleX(-1)' }}
      />
    }
    fitContent
  >
    <DetailRows
      rows={buildDetailCards(data, resourceHeaders, langKey).meter}
      data={data}
      isEditMode={isEditMode}
      editedData={editedData}
      onFieldChange={onFieldChange}
      emptyMessage={langKey === 'he' ? 'אין פרטי מד להצגה' : 'No meter details'}
    />
  </DetailCard>
)

export default MeterInfoCard
